import { render, staticRenderFns } from "./template.html?vue&type=template&id=1dbf2264&scoped=true&"
import script from "./show.vue?vue&type=script&lang=js&"
export * from "./show.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=1dbf2264&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbf2264",
  null
  
)

export default component.exports